import React from "react";
import { Block } from "@randajan/jet-react/dom/block";

import { PersonalPanel } from "./PersonalPanel/PersonalPanel";
import { CreditsPanel } from "./CreditsPanel/CreditsPanel";
import { MailMePanel } from "./MailMePanel/MailMePanel";
import { ConsentsPanel } from "./ConsentsPanel/ConsentsPanel";

import "./ProfilePrivate.scss";

export const ProfilePrivate = (props)=>{
    const { profile={} } = props;

    return (
        <Block tagName="section" className="ProfilePrivate">
            <PersonalPanel profile={profile} />
            <MailMePanel profile={profile} />
            <ConsentsPanel profile={profile} />
            <CreditsPanel profile={profile} />
        </Block>
    );
};
